<template>
   <div class="container">
      <div class="center">
         <div class="nav-bar">
            <p>
               <span class="parent-link"  @click="navToHome()" >Admin</span>
               <span> >> </span>
               <span> {{title}} </span>
            </p>
         </div>
         <div  class="nav-select" style="width:100%;margin-top: 15px;">
            <div>
                <span>用户名</span>
                <el-input placeholder="请在此输入正确的账号" v-model="username" class="input-with-select">    
                </el-input>
            </div>
            <div style="margin-left:30px;">
                <span>平台</span>
                <el-select v-model="platform" clearable placeholder="请输入平台" class="input-with-select">
                    <el-option
                            v-for="item in setHospital"
                            :key="item.value"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <div style="margin-left:30px;">
                <span>数据类型</span>
                <el-input placeholder="请在此输入数据类型" v-model="flag" class="input-with-select">    
                </el-input>
            </div>
            <div style="margin-left:30px;">
                <el-button @click="select">搜索</el-button>
            </div>
         </div>
         <div class="tables">
            <el-table
                :data="tableData.slice((currentPage-1)*pagesize,currentPage*pagesize)"
                stripe
                 @cell-click="ceclick"
                style="width: 100%">
                <el-table-column
                    prop="uid"
                    label="UID"
                    width="100px">
                </el-table-column>
                <el-table-column
                    prop="id"
                    label="ID"
                    width="120px">
                </el-table-column>
                <el-table-column
                prop="username"
                label="用户名"
                >
                </el-table-column>
                <el-table-column
                prop="uploadTime"
                label="上传日期">
                </el-table-column>
                <el-table-column
                prop="flag"
                label="flag">
                </el-table-column>
                <el-table-column
                prop="platform"
                label="平台">
                </el-table-column>
            </el-table>
            <el-pagination class="fy"
                layout="prev, pager, next, jumper"
                @current-change="current_change"
                :total="total"
                background
                :current-page.sync ="filterPage"
                >
            </el-pagination>
         </div>
      </div>
   </div>
</template>

<script>
import {format} from './method'
export default {
   data() {
      return {
         platform:'',
         username:'',
         flag:'',
         setHospital: [
            {id: 'ios', name: 'ios'},
            {id: 'google', name: 'google'}
        ],
        tableData: [],
        searData:[],
        title:'DevDebug',
        pagesize: 10,
        currentPage: 1,
        filterPage: 1,
        total:0
      }
   },
   methods:{
    current_change: function (currentPage) {
        this.currentPage = currentPage
    },
    //返回界面
    navToHome() {
        this.$router.push('/accountsadmin_home')
    },
    // 数据加载
    search () {
        let val ={
            num:100
        }
        let that =this
        this.$http.post('/api/v2.1/admin/devdebug/get_rtd',val).then(res => {
            if(res.status ===200){
                that.searData =res.data.data
                for(let i =0;i< that.searData.length;i++){
                    that.searData[i].uploadTime =format(that.searData[i].uploadTime)
                }
                that.tableData =that.searData
                that.total =res.data.data.length
            }else{
            }
        })
    },
    
    //筛选
    select (){
        //对平台的筛选
        let Data1 =[]
        let Data2 =[]
        let Data3 =[]
        if(this.platform){
            for(let i=0;i<this.searData.length;i++){
                if(this.searData[i].platform===this.platform){
                    Data1.push(this.searData[i])
                }
            }
        }else{
            Data1=this.searData
        }
        //对数据类型的筛选
        if(this.flag){
            for(let i=0;i<Data1.length;i++){
                if(Data1[i].flag===this.flag){
                    Data2.push(Data1[i])
                }
            }
        }else{
            Data2=Data1
        }
        // 对用户名的筛选
        if(this.username){
            let arr = this.username.split(',')
            for(let i=0;i<Data2.length;i++){
                for(let j=0;j<arr.length;j++){
                    if(Data2[i].username.search(arr[j])!=-1){
                        Data3.push(Data2[i])
                        break
                    }
                }
            }
        }else{
            Data3 =Data2
        }
        this.tableData =Data3
        this.currentPage = 1
        this.filterPage = 1
        this.total =this.tableData.length
        
    },
    //用户点击事件
    ceclick: function (item) {
        this.$router.push({path: '/BasicQuantityRecord', query: item})
    },
   },
   computed: {
   },
   created() {
    let that = this;
    document.onkeydown =function(e){
      e = window.event || e;
      if(that.$route.path==='/UserAdmin'&&(e.code==='Enter'||e.code==='enter'||e.code==='NumpadEnter')&&!e.isComposing){//验证在登录界面和按得键是回车键enter
        that.search();//搜索函数
        }
      }
    },
    mounted(){
        this.search();
    }
}
</script>

<style scoped>
  .container {
    height:100%;
    background-color:#ffffff;
  }

  .container .center {
    width: 75%;
    margin: 0 auto;
  }

  .container .center .no-data {
    padding-top: 5%;
  }
  .container .center .nav-bar {
    padding-top: 50px;
    border-bottom: 1px solid #ccc;
    padding-bottom: 5px;
  }
  .container .center .nav-bar span{
    cursor: pointer;
  }
  .container .center .nav-select {
   display: flex;
   justify-content: flex-start;
    border-bottom: 1px solid #ccc;
    padding-bottom: 15px;
  }
  .operate{
    display: flex;
    justify-content: space-between;
  }
  .input-with-select {
     width: 200px;
     margin-left: 3px;
  }
  .from-item {
     width: 300px;
  }
  .span1 {
     display: inline-block;
     width: 120px;
     font-size: 20px;
     text-align: left;
     padding-right: 12px;
  }
  .span2 {
   display: inline-block;
   font-size: 20px;
  }
  .dialog {
     width: 800px;
     margin-left: 50%;
     margin-top: 300px;
     left: -400px;
  }
  .tables{
      margin-top: 20px;
  }
  .fy {
      margin-top: 20px;
      width: 100%;
  }
  /deep/ .el-table td, /deep/ .el-table th {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// DevDebug.vue?47dc3410